/* My Acre — variant to gallery bridge. 9 Sep 2026 (Claude, Hayden approved).
 *
 * THE FAULT: picking a colour changed the price, the SKU and the chosen-value label, but the
 * main gallery never moved. The theme does ship a gallery.selectMediaByVariant() (superstore.js),
 * but our custom picker (.ma-options radios, see snippets/product-options.liquid) writes straight
 * to the hidden select and the theme's own variant-change listener never hears it, so the call
 * is never made. On Aluvy that meant clicking Reseda while looking at a Blanc brazier.
 *
 * THE FIX: listen on the picker ourselves, resolve the selected variant to its media id, and
 * CLICK the matching thumbnail. Going through the theme's own thumbnail handler rather than
 * poking the slider directly keeps the slide transition, the zoom target and the thumbnail
 * selected-state all behaving exactly as they already do.
 *
 * Requires each variant to have media attached (productVariantAppendMedia). Where a variant has
 * no media of its own the script does nothing, which leaves the gallery where the customer left
 * it. That is the correct behaviour, not a failure.
 */
(function () {
  'use strict';
  if (window.__maVariantGallery) return;
  window.__maVariantGallery = true;

  var variantToMedia = null;

  function handle() {
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = canonical ? new URL(canonical.href).pathname : window.location.pathname;
    var m = path.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function load() {
    var h = handle();
    if (!h) return Promise.resolve(null);
    return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.media) return null;
        var map = {};
        p.media.forEach(function (item) {
          (item.variant_ids || []).forEach(function (vid) {
            if (map[vid] == null) map[vid] = item.id;   // first media wins, matching Shopify
          });
        });
        return map;
      })
      .catch(function () { return null; });
  }

  function selectedVariantId() {
    var sel = document.querySelector('[data-product-options-container] select[name="id"], form[data-product-form] select[name="id"], form[data-product-form] input[name="id"]');
    return sel && sel.value ? String(sel.value) : null;
  }

  function show(mediaId) {
    var thumb = document.querySelector('.product-gallery--media-thumbnail[data-media="' + mediaId + '"]');
    if (thumb && thumb.getAttribute('data-gallery-selected') !== 'true') { thumb.click(); return; }
    // Thumbnails are hidden when a product has a single image; move the viewer directly instead.
    var fig = document.querySelector('figure[data-gallery-figure][data-media="' + mediaId + '"]');
    if (fig && fig.getAttribute('data-gallery-selected') !== 'true' && typeof fig.scrollIntoView === 'function') {
      fig.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  function sync() {
    if (!variantToMedia) return;
    var vid = selectedVariantId();
    if (!vid) return;
    var mediaId = variantToMedia[vid];
    if (mediaId) show(mediaId);
  }

  function bind() {
    var scope = document.querySelector('[data-product-options-container]') || document;
    // The picker updates the hidden select, so listen for both the radio click and the resulting
    // change. A rAF lets the theme finish writing the select before we read it.
    ['change', 'click'].forEach(function (ev) {
      scope.addEventListener(ev, function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('.ma-option-value, .ma-options, select[name="id"]')) return;
        requestAnimationFrame(function () { requestAnimationFrame(sync); });
      }, true);
    });
  }

  function init() {
    if (!document.querySelector('[data-product-gallery]')) return;
    load().then(function (map) {
      if (!map) return;
      variantToMedia = map;
      bind();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
